var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-reasons wrap"},[_c('h2',[_vm._v("Price")]),_c('p',{staticClass:"sub-title"},[_vm._v("制作料金")]),_c('p',[_vm._v(" ホームページ制作料金は、基本的に「制作工数＝料金」となります。そのため、ここで説明したアプローチによって、コストカットをすることができます。ホームページで実現したい目的を意識しつつ、コストカットのアプローチをすることで、最低11万円(税込)からホームページの制作ができます。"),_c('span',{staticClass:"kome"},[_vm._v("※制作料とは別途で保守費用が発生します")])])])
}]

export { render, staticRenderFns }